module.exports = __webpack_public_path__ + "img/wifi-normal.532aebfc.svg";